
import { defineComponent } from 'vue';

export default defineComponent({
    /*テキストボックス*/
    name: 'TextBox',
    props: {
        modelValue: {
            type: String,
        },
        title: {
            type: String,
        },
        isPassword: {
            type: Boolean,
            default: false,
        },
        isError: {
            type: Boolean,
            default: false,
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
        isMurkyBlue: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, context) {
        const onInput = (event: Event) => {
            if (!(event.target instanceof HTMLInputElement)) {
                return;
            }
            context.emit('update:modelValue', event.target.value);
        };
        return {
            onInput,
        };
    },
    emits: ['update:modelValue'],
});
